module.exports = __webpack_public_path__ + "static/media/placeholder.7eade072.jpg";